import apiActions from 'app/utils/apiActions';

const journalChatActions = {
  generate: (currentText, currentTitle, currentValueId, conversationHistory = [], followUp = null, useClaude = false) =>
    apiActions.request('journal_chat', 'POST', {
      current_text: currentText,
      current_title: currentTitle,
      current_value_id: currentValueId,
      conversation_history: conversationHistory,
      follow_up: followUp,
      use_claude: useClaude,
    }),
};

export default journalChatActions;
